import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useEventListener } from '../hooks';

import { Logo } from '../components';

import { headerNavList } from '../copies';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      window.document.body.classList.add('overflow-hidden');
    } else {
      window.document.body.classList.remove('overflow-hidden');
    }
  }, [isMenuOpen]);

  useEventListener('scroll', () => {
    setScrolled(window.scrollY > 10);
  });

  return (
    <header
      className={`fixed inset-x-0 z-50 transition-shadow bg-white dark:bg-gray-900 dark:text-white ${
        scrolled && !isMenuOpen
          ? 'bg-opacity-90 shadow-lg'
          : 'shadow-none md:bg-gray-50'
      }`}
      style={{
        backdropFilter: scrolled && !isMenuOpen ? 'blur(5px)' : '',
      }}
    >
      <div className="px-6 md:px-10">
        <div className="h-20 flex justify-between items-center container max-w-screen-xl mx-auto space-x-6">
          <div className="flex-1">
            <Link to="/" onClick={() => setIsMenuOpen(false)}>
              <Logo />
            </Link>
          </div>

          {/* Navigation */}
          <nav className="hidden lg:block flex-1">
            <ul className="flex items-center justify-center space-x-8 lg:space-x-12">
              {headerNavList.map(({ label, url }) => (
                <li
                  className="opacity-80 hover:opacity-100 transition-opacity cursor-pointer"
                  key={label}
                >
                  <Link to={url}>{label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Login/Register */}
          <ul className="hidden lg:flex items-center justify-end space-x-4 flex-1">
            <li>
              <Link
                to="/sign-in"
                className="opacity-80 hover:opacity-100 transition-opacity py-2 px-5 focus:outline-none text-primary-600 dark:text-primary-500 whitespace-nowrap"
              >
                Sign in
              </Link>
            </li>
            <li>
              <Link
                to="/sign-up"
                className="bg-primary-600 hover:bg-primary-700 text-white py-2 px-5 rounded-md transition-opacity focus:outline-none focus:ring-4 focus:ring-primary-600 focus:ring-opacity-50 whitespace-nowrap"
              >
                Sign up
              </Link>
            </li>
          </ul>

          {/* Menu & Close icon */}
          {isMenuOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="block lg:hidden h-8 w-8 flex-shrink-0"
              onClick={() => setIsMenuOpen(false)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="block lg:hidden h-8 w-8 flex-shrink-0"
              onClick={() => setIsMenuOpen(true)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </div>
      </div>

      {/* Mobile navigation */}
      {isMenuOpen ? (
        <div className="container max-w-screen-xl mx-auto block lg:hidden py-4 bg-white dark:bg-gray-900 dark:text-white h-screen">
          <div className="px-6 md:px-10">
            <nav>
              <ul className="space-y-6">
                {headerNavList.map(({ label, url }) => (
                  <li className="cursor-pointer" key={label}>
                    <Link to={url} onClick={() => setIsMenuOpen(false)}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <hr className="w-full h-0 border-t my-6" />

            <div className="space-y-4 max-w-sm mx-auto">
              <Link
                to="/sign-in"
                onClick={() => setIsMenuOpen(false)}
                className="py-2 px-5 focus:outline-none dark:text-primary-500 text-primary-600 whitespace-nowrap w-full block text-center"
              >
                Sign in
              </Link>
              <Link
                to="/sign-up"
                onClick={() => setIsMenuOpen(false)}
                className="bg-primary-600 hover:bg-primary-700 text-white py-2 px-5 rounded-md transition-opacity focus:outline-none focus:ring-4 focus:ring-primary-600 focus:ring-opacity-50 whitespace-nowrap w-full block text-center"
              >
                Sign up
              </Link>
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
};

export default Header;
